import { cn } from '@poseidon/components/cn';
import { ToggleSwitch } from '@poseidon/components/Input2';

/**
 * Compact pill shown on a connect touch's "not accepted" fork elbow that
 * surfaces — and toggles — that connect step's auto-withdraw flag. When on, a
 * still-pending LinkedIn invitation is withdrawn once the No (not-accepted)
 * branch resolves.
 *
 * Mirrors the list view's `AutoWithdrawChip` (see `CampaignWaitForConnectPure`)
 * so the graph and list surfaces read the same. `onChange` omitted → a
 * read-only "On/Off" label; `onChange` provided → an interactive `ToggleSwitch`.
 *
 * Carries `data-control` so a drag starting on the pill pans nothing (the
 * canvas treats `[data-control]` targets as controls, not empty space).
 */
export function TouchAutoWithdrawChip({
  blockId,
  checked,
  onChange,
}: {
  /** Owning connect touch's block id — namespaces the test ids. */
  blockId: string;
  checked: boolean;
  onChange?: (value: boolean) => void;
}) {
  const readOnly = onChange == null;
  return (
    <span
      data-control="autowithdraw"
      data-testid={`touch-wfc-autowithdraw-${blockId}`}
      className={cn(
        'inline-flex w-fit items-center gap-1.5 rounded-full border px-2 py-0.5 text-[10px] font-semibold shadow-sm',
        'border-lynch-300 bg-lynch-50 text-lynch-800',
        'dark:border-slate-600 dark:bg-slate-800 dark:text-lynch-200',
      )}>
      <span>Auto-withdraw</span>
      {readOnly && (
        <span data-testid={`touch-wfc-autowithdraw-state-${blockId}`} className="text-lynch-600 dark:text-lynch-400">
          {checked ? 'On' : 'Off'}
        </span>
      )}
      {!readOnly && (
        <ToggleSwitch
          data-testid={`touch-wfc-autowithdraw-toggle-${blockId}`}
          size="2xs"
          color="blue"
          checked={checked}
          onChange={onChange}
        />
      )}
    </span>
  );
}
